import React, { useState } from 'react';
import { Modal, Tooltip, Tabs } from 'antd';
import { SpanButton } from 'component/button_components/button.style';
import { ReactComponent as ViewIcon } from 'assets/images/SVG/icons/view-icon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { getSingleGroup } from 'redux/slices/getOuGroups';
import TabPane from 'antd/es/tabs/TabPane';
import { Data, DataContainer, GroupTabContainer, Label, ViewRowWrapper, ViewUserConatiner } from '../viewUser/style';

const ViewGroup = ({ ...record }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [singleGroupData, setSingleGrouprData] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const dispatch = useDispatch();
  const selectedNode = useSelector((state) => state.selectedNode);

  const showModal = async () => {
    try {
      const response = await dispatch(getSingleGroup({ GroupName: record.groupName, fqdn: selectedNode.domainName }));
      if (response.payload && response.payload.status === 200) {
        setSingleGrouprData(response.payload.data[0]);
        setIsModalOpen(true);
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip className='action-tooltip action-tooltip-group' title='View Group' color='#597081'>
        <SpanButton onClick={showModal} className='action-spanbutton action-spanbutton-group'>
          <ViewIcon className='action-icon action-icon-group-view' />
        </SpanButton>
      </Tooltip>
      {isModalOpen && (
        <Modal
          open={isModalOpen}
          width={800}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[]}
          centered
          maskClosable={false}
          className='modal-style modal-viewgroup'
        >
          <h2 className='modal-viewgroup-heading'>View Group</h2>

          <ViewUserConatiner className='viewgroup-container'>
            <Tabs
              className='af-form-tab af-viewgroup-form-tab'
              activeKey={activeTab}
              defaultActiveKey='1'
              onChange={handleTabChange}
              tabPosition='top'
              tabBarGutter={20}
            >
              <TabPane
                tab='Account'
                key='1'
                className='af-form-tab-tabpane af-viewgroup-form-tab-tabpane af-viewgroup-form-tab-tabpane_account'
              >
                <ViewRowWrapper className='viewgroup viewgroup-wrap viewgroup-wrap-wrap1'>
                  <DataContainer className='viewgroup-item viewgroup-item-group_name'>
                    <Label className='viewgroup-label viewgroup-label-group_name'>Group Name:</Label>
                    <Data className='viewgroup-data viewgroup-data-group_name'>{singleGroupData?.groupName}</Data>
                  </DataContainer>
                  <DataContainer className='viewgroup-item viewgroup-item-group_name_prewin'>
                    <Label className='viewgroup-label viewgroup-label-group_name_prewin'>
                      Group Name (Pre Win 2000):
                    </Label>
                    <Data className='viewgroup-data viewgroup-data-group_name_prewin'>
                      {singleGroupData?.namePreWin}
                    </Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewgroup viewgroup-wrap viewgroup-wrap-wrap2'>
                  <DataContainer className='viewgroup-item viewgroup-item-ou'>
                    <Label className='viewgroup-label viewgroup-label-ou'>OU:</Label>
                    <Data className='viewgroup-data viewgroup-data-ou'>{singleGroupData?.ouName}</Data>
                  </DataContainer>
                  <DataContainer className='viewgroup-item viewgroup-item-email'>
                    <Label className='viewgroup-label viewgroup-label-email'>E-mail:</Label>
                    <Data className='viewgroup-data viewgroup-data-email'>{singleGroupData?.email}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewgroup viewgroup-wrap viewgroup-wrap-wrap3'>
                  <DataContainer className='viewgroup-item viewgroup-item-group_scope'>
                    <Label className='viewgroup-label viewgroup-label-group_scope'>Group Scope:</Label>
                    <Data className='viewgroup-data viewgroup-data-group_scope'>
                      {singleGroupData?.groupScope === 0
                        ? 'BuiltIn Local'
                        : singleGroupData?.groupScope === 1
                        ? 'Global'
                        : singleGroupData?.groupScope === 2
                        ? 'Universal'
                        : ''}
                    </Data>
                  </DataContainer>
                  <DataContainer className='viewgroup-item viewgroup-item-group_type'>
                    <Label className='viewgroup-label viewgroup-label-group_type'>Group Type:</Label>
                    <Data className='viewgroup-data viewgroup-data-group_type'>
                      {singleGroupData?.groupType === 2 ? 'Distribution' : 'Security'}
                    </Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewgroup viewgroup-wrap viewgroup-wrap-wrap4'>
                  <DataContainer className='singlelabel viewgroup-item viewgroup-item-description'>
                    <Label className=' viewgroup-label viewgroup-label-description'>Description:</Label>
                    <Data className=' viewgroup-data viewgroup-data-description'>{singleGroupData?.description}</Data>
                  </DataContainer>
                </ViewRowWrapper>
                <ViewRowWrapper className='viewgroup viewgroup-wrap viewgroup-wrap-wrap5'>
                  <DataContainer className='singlelabel viewgroup-item viewgroup-item-notes'>
                    <Label className=' viewgroup-label viewgroup-label-notes'>Notes :</Label>
                    <Data className=' viewgroup-data viewgroup-data-notes'>{singleGroupData?.notes}</Data>
                  </DataContainer>
                </ViewRowWrapper>
              </TabPane>
              <TabPane
                tab='Group Members'
                key='2'
                className='af-form-tab-tabpane af-viewgroup-form-tab-tabpane af-viewgroup-form-tab-tabpane_group_members'
              >
                <GroupTabContainer className='viewgroup-tabconatiner'>
                  {singleGroupData?.groupMembers && singleGroupData?.groupMembers.length > 0 ? (
                    <ul className='view-grouplist-list-ul' style={{ listStyleType: 'disclosure-closed' }}>
                      {singleGroupData?.groupMembers.map((member, index) => (
                        <li className='groupviewlist view-grouplist-list-li' key={index}>
                          {member.name} ({member.type})
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className='groupviewlist view-group-list-none'>No Member(s) Found</p>
                  )}
                </GroupTabContainer>
              </TabPane>
              <TabPane
                tab='Member Of'
                key='3'
                className='af-form-tab-tabpane af-viewgroup-form-tab-tabpane af-viewgroup-form-tab-tabpane_members_of'
              >
                <GroupTabContainer>
                  {singleGroupData?.membersOf && singleGroupData?.membersOf.length > 0 ? (
                    <ul className='view-grouplist-list-ul' style={{ listStyleType: 'disclosure-closed' }}>
                      {singleGroupData?.membersOf.map((member, index) => (
                        <li className='groupviewlist view-grouplist-list-li' key={index}>
                          {member}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className='groupviewlist view-group-list-none'>No Group(s) Found</p>
                  )}
                </GroupTabContainer>
              </TabPane>
            </Tabs>
          </ViewUserConatiner>
        </Modal>
      )}
    </>
  );
};

export default ViewGroup;
